<template>
    <table class="table">
        <thead>
            <tr>
                <th>Venue name</th>
                <th>Amount</th>
                <th>Notes</th>
                <th>Status</th>
                <th />
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="(venue, index) in venues"
                :key="index"
            >
                <td>
                    <EditableAccountSelect
                        tooltip="Click to change venue..."
                        :value="venue.account"
                        @save="saveEditableField(venue, 'venue_id', $event)"
                    >
                        <div v-if="venue.account.name">
                            {{ venue.account.name }}
                        </div>
                        <i
                            v-else
                            class="fa fa-fw fa-plus"
                        />
                    </EditableAccountSelect>
                </td>
                <td>
                    <EditableInput
                        tooltip="Click to change amount..."
                        :value="formatFloat(venue.amount)"
                        @save="saveEditableField(venue, 'amount', $event)"
                    >
                        <div v-if="venue.amount">
                            {{ formatCurrency(venue.amount) }}
                        </div>
                        <i
                            v-else
                            class="fa fa-fw fa-plus"
                        />
                    </EditableInput>
                </td>
                <td>
                    <EditableTextarea
                        tooltip="Click to edit notes..."
                        :value="venue.notes"
                        :markdown="true"
                        @save="saveEditableField(venue, 'notes', $event)"
                    >
                        <div
                            v-if="venue.notes_html"
                            v-html="venue.notes_html"
                        />
                        <i
                            v-else
                            class="fa fa-fw fa-plus"
                        />
                    </EditableTextarea>
                </td>
                <td>
                    <EditableSelect
                        tooltip="Click to edit status..."
                        :options="statuses"
                        :value="venue.status"
                        @save="saveEditableField(venue, 'status', $event)"
                    >
                        <span v-if="venue.status">
                            {{ venue.status }}
                        </span>

                        <i
                            v-else
                            class="fa fa-fw fa-plus"
                        />
                    </EditableSelect>
                </td>
                <td class="d-flex justify-content-end">
                    <b-btn
                        variant="danger"
                        size="xs"
                        class="ml-auto"
                        @click="showDeleteModal(venue.id)"
                    >
                        Remove
                    </b-btn>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { get, call } from 'vuex-pathify';
import EditableTextarea from '@/components/EditableTextarea';
import EditableAccountSelect from '@/components/EditableAccountSelect';
import EditableSelect from '@/components/EditableSelect';
import EditableInput from '@/components/EditableInput.vue';
import { formatCurrency, formatFloat } from '@/utils/helpers';

export default {
    components: {
        EditableInput,
        EditableTextarea,
        EditableAccountSelect,
        EditableSelect,
    },
    computed: {
        venues: get('venues/venues'),
        statuses: get('venues/statuses'),
    },
    methods: {
        formatCurrency,
        formatFloat,
        async saveEditableField(venue, field, { value, done }) {
            const data = {
                id: venue.id,
            };

            data[field] = value;

            await this.$store.dispatch('venues/updateVenue', data);
            done();
        },
        showDeleteModal: call('venues/setDeleteVenueId'),
    },
};
</script>

<style scoped>

</style>
